import { render } from "./Trademarks.vue?vue&type=template&id=004d948c&scoped=true"
import script from "./Trademarks.vue?vue&type=script&lang=js"
export * from "./Trademarks.vue?vue&type=script&lang=js"

import "./Trademarks.vue?vue&type=style&index=0&id=004d948c&scoped=true&lang=css"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004d948c"]])

export default __exports__